(function(){
  'use strict';
  function init(root){
    if(!root || root.dataset.ecoEnhancedInit==='true') return;
    root.dataset.ecoEnhancedInit='true';

    // Hero gallery — mobile uses the approved clean Features image without the cropped text strip.
    var mainWrap=root.querySelector('[data-gallery-main]');
    var mainImg=mainWrap?mainWrap.querySelector('img'):null;
    function gallerySource(btn){
      if(window.matchMedia('(max-width:600px)').matches && btn.getAttribute('data-gallery-src-mobile')){
        return btn.getAttribute('data-gallery-src-mobile');
      }
      return btn.getAttribute('data-gallery-src');
    }
    function setGallery(btn){
      if(!mainImg || !btn)return;
      root.querySelectorAll('[data-gallery-src]').forEach(function(x){x.classList.remove('is-active','active');});
      btn.classList.add('is-active');
      mainImg.src=gallerySource(btn);
      mainImg.alt=btn.getAttribute('data-gallery-alt')||'Enhanced Adjustable Base';
    }
    root.querySelectorAll('[data-gallery-src]').forEach(function(btn){
      btn.addEventListener('click',function(){setGallery(btn);});
    });
    var galleryMedia=window.matchMedia('(max-width:600px)');
    function refreshResponsiveGallery(){
      var active=root.querySelector('[data-gallery-src].is-active,[data-gallery-src].active');
      if(active && mainImg) mainImg.src=gallerySource(active);
    }
    if(galleryMedia.addEventListener) galleryMedia.addEventListener('change',refreshResponsiveGallery);

    var form=root.querySelector('#eco-enhanced-product-form');
    var variantInput=root.querySelector('[data-variant-input]');
    var currentPrice=root.querySelector('[data-current-price]');
    var comparePrice=root.querySelector('[data-compare-price]');
    var saveBadge=root.querySelector('[data-save-badge]');
    var add=root.querySelector('[data-add-to-cart]');
    var finalPrice=root.querySelector('[data-final-price]');
    var finalCompare=root.querySelector('[data-final-compare]');
    var finalAdd=root.querySelector('[data-final-add]');
    var finalAddtocart=root.querySelector('[data-final-addtocart]');

    function selectVariant(id){
      var source=root.querySelector('.buy .size[data-variant-id="'+id+'"]');
      if(!source || source.disabled) return;
      root.querySelectorAll('.size[data-variant-id]').forEach(function(b){
        var on=b.getAttribute('data-variant-id')===id;
        b.classList.toggle('active',on); b.setAttribute('aria-pressed',on?'true':'false');
      });
      if(variantInput) variantInput.value=id;
      var price=source.getAttribute('data-variant-price')||'';
      var compare=source.getAttribute('data-variant-compare')||'';
      var save=source.getAttribute('data-variant-save')||'';
      var available=source.getAttribute('data-variant-available')==='true';
      if(currentPrice) currentPrice.textContent=price;
      if(finalPrice) finalPrice.textContent=price;
      if(comparePrice){comparePrice.hidden=!compare; comparePrice.textContent=compare?('Regular price '+compare):'';}
      if(finalCompare){finalCompare.hidden=!compare; finalCompare.textContent=compare;}
      if(saveBadge){saveBadge.hidden=!save; saveBadge.textContent=save?('SAVE '+save):'';}
      [add,finalAdd].forEach(function(b){if(b){b.disabled=!available;b.textContent=available?'Add to Cart':'Sold Out';}});
      if(window.history&&window.history.replaceState){var u=new URL(window.location.href);u.searchParams.set('variant',id);window.history.replaceState({},'',u.toString());}
    }
    root.querySelectorAll('.buy .size[data-variant-id]').forEach(function(b){b.addEventListener('click',function(){selectVariant(b.getAttribute('data-variant-id'));});});
    root.querySelectorAll('[data-final-size]').forEach(function(b){b.addEventListener('click',function(){selectVariant(b.getAttribute('data-variant-id'));});});

    // Quantity
    var qDisplay=root.querySelector('[data-qty-display]');
    var qInput=root.querySelector('[data-quantity-input]');
    function setQty(v){v=Math.max(1,parseInt(v||1,10)||1); if(qDisplay)qDisplay.value=v;if(qInput)qInput.value=v;}
    var qMinus=root.querySelector('[data-qty-minus]'),qPlus=root.querySelector('[data-qty-plus]');
    if(qMinus)qMinus.addEventListener('click',function(){setQty((qDisplay?qDisplay.value:1)-1);});
    if(qPlus)qPlus.addEventListener('click',function(){setQty(parseInt(qDisplay?qDisplay.value:1,10)+1);});
    if(qDisplay)qDisplay.addEventListener('change',function(){setQty(qDisplay.value);});

    // Final CTA submits the primary Shopify product form.
    if(finalAdd)finalAdd.addEventListener('click',function(){if(form && !finalAdd.disabled){if(form.requestSubmit)form.requestSubmit();else form.submit();}});

    // suresh.katiki
    if (finalAddtocart) {
      finalAddtocart.addEventListener('click', function () {
        var target = document.getElementById('eco-enhanced-product-form');

        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    }

    // Position visual selector
    var posImg=root.querySelector('#positionRender');
    var posTitle=root.querySelector('#positionActiveTitle');
    var posDesc=root.querySelector('#positionActiveDescription');
    root.querySelectorAll('.position-selector [data-position]').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('.position-selector [data-position]').forEach(function(x){x.classList.remove('active');x.setAttribute('aria-pressed','false');});
        btn.classList.add('active');btn.setAttribute('aria-pressed','true');
        if(posImg){posImg.style.opacity='.2';window.setTimeout(function(){posImg.src=btn.getAttribute('data-position-src');posImg.alt='Enhanced Adjustable Base — '+btn.getAttribute('data-position-title');posImg.style.opacity='1';},100);}
        if(posTitle)posTitle.textContent=btn.getAttribute('data-position-title')||btn.textContent.trim();
        if(posDesc)posDesc.textContent=btn.getAttribute('data-position-description')||'';
      });
    });

    // Split King left/right focus controls
    var splitPhoto=root.querySelector('#splitPhoto');
    root.querySelectorAll('.splitcontrols button[data-state]').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('.splitcontrols button[data-state]').forEach(function(x){x.classList.remove('active');});
        btn.classList.add('active');
        if(!splitPhoto)return;
        splitPhoto.classList.remove('flip','view-left','view-right');
        if(btn.dataset.state==='left')splitPhoto.classList.add('view-left');
        if(btn.dataset.state==='right')splitPhoto.classList.add('flip','view-right');
      });
    });
  }
  function initAll(){document.querySelectorAll('.eco-enhanced-pdp').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.eco-enhanced-pdp');if(r)init(r);});
})();
